export function convertTimeTohhmm(time: string): string {
  const [hours, minutes] = time.split(":");
  return `${hours}:${minutes}`;
}

export function lastUpdatedValid(
  lastUpdated: string,
  validPeriodInMinutes: number,
): boolean {
  const lastUpdatedDate = new Date(lastUpdated);
  const currentTime = new Date();
  const maxAgeInMilliseconds = validPeriodInMinutes * 60 * 1000;
  return (
    currentTime.getTime() - lastUpdatedDate.getTime() <= maxAgeInMilliseconds
  );
}

// 20.15 to 1215 minutes.
export function convertDotTimeToMinutes(time: string): number {
  const [hours, minutes] = time.split(".");
  return parseInt(hours) * 60 + parseInt(minutes);
}
